import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Table } from 'react-bootstrap';
export default function ClaimGroupUserAccessForm(_ref) {
  let {
    clientContact,
    setClientContact
  } = _ref;
  const roles = window.MARKET_CONSTANTS.ENGAGEMENT_TEAM_ROLES;
  const {
    t
  } = useTranslation();
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const updatedFields = {
      [e.target.name]: value
    };

    // if the client does not have claim group document access - they automatically dont have full document access
    if (e.target.name === 'has_claim_group_document_access' && !value) {
      updatedFields['has_full_claim_group_document_access'] = false;
    }
    setClientContact({
      ...clientContact,
      ...updatedFields
    });
  };
  const handleIncludeEngagementTeam = event => {
    setClientContact({
      ...clientContact,
      included_in_engagement_team: event.target.checked
    });
  };
  const handleAddRole = event => {
    const roles = clientContact.roles;
    if (event.target.checked) {
      roles.push(event.target.value);
      setClientContact({
        ...clientContact,
        roles: roles,
        included_in_engagement_team: event.target.value === 'client_sponsor' ? true : clientContact.included_in_engagement_team
      });
    } else {
      setClientContact({
        ...clientContact,
        roles: roles.filter(role => role !== event.target.value)
      });
    }
  };
  return /*#__PURE__*/React.createElement(Table, {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "dashboard_access",
    checked: clientContact.dashboard_access,
    value: clientContact.dashboard_access,
    name: "dashboard_access",
    label: t('access_to_company_dashboard'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "included_in_engagement_team",
    checked: clientContact.included_in_engagement_team,
    value: clientContact.included_in_engagement_team,
    name: "included_in_engagement_team",
    label: t('engagement_team'),
    className: "ms-2 mt-2",
    onChange: handleIncludeEngagementTeam
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "has_data_centre_project_data_access",
    checked: clientContact.has_data_centre_project_data_access,
    value: clientContact.has_data_centre_project_data_access,
    name: "has_data_centre_project_data_access",
    label: t('has_data_centre_project_data_access'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "has_data_centre_cost_data_access",
    checked: clientContact.has_data_centre_cost_data_access,
    value: clientContact.has_data_centre_cost_data_access,
    name: "has_data_centre_cost_data_access",
    label: t('has_data_centre_cost_data_access'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "can_create_new_projects",
    checked: clientContact.can_create_new_projects,
    value: clientContact.can_create_new_projects,
    name: "can_create_new_projects",
    label: t('can_create_new_projects'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "has_claim_group_document_access",
    checked: clientContact.has_claim_group_document_access,
    value: clientContact.has_claim_group_document_access,
    name: "has_claim_group_document_access",
    label: t('has_claim_group_document_access'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "has_full_claim_group_document_access",
    checked: clientContact.has_full_claim_group_document_access,
    value: clientContact.has_full_claim_group_document_access,
    name: "has_full_claim_group_document_access",
    label: t('has_full_claim_group_document_access'),
    disabled: !clientContact.has_claim_group_document_access,
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    id: "access_to_signed_off_rnd_report",
    checked: clientContact.access_to_signed_off_rnd_report,
    value: clientContact.access_to_signed_off_rnd_report,
    name: "access_to_signed_off_rnd_report",
    label: t('access_to_signed_off_rnd_report'),
    className: "ms-2",
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("tbody", {
    "data-testid": "clientContactModalBody"
  }, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "border-0 font-weight-normal",
    style: {
      width: '20%'
    }
  }, t('role'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: '20%'
    }
  }, roles.map(role => {
    return /*#__PURE__*/React.createElement(Form.Check, {
      key: role.value,
      id: role.value,
      checked: clientContact.roles.includes(role.value),
      value: role.value,
      name: role.value,
      label: t(role.value),
      onChange: e => handleAddRole(e)
    });
  })))));
}